import {createTheme} from "@mui/material/styles";

const default_theme = createTheme({
    palette: {
        primary: {
            main: '#ffffff', // white
            bgcolor: '#faf0dc',
            black: '#000000'
        },
        secondary: {
            main: '#0fe880', // Green
            bgcolor: '#00b894'
        },
        other: {
            main: '#3b3b3b', // Black
        },
    },
});

export default default_theme;